import $ from 'jquery'
import IMask from 'imask'

const maskOptions = {
    mask: Number,
    scale: 2,
    signed: false,
    thousandsSeparator: ' ',
    radix: '.',
    mapToRadix: [','],
    normalizeZeros: false
}

class Module {
    constructor($module) {
        this.$container = $module;
        this.$walletSelector = $module.find('.auto_replenishment_rule_wallet');
        this.$walletInput = $module.find('#auto_replenishment_rule_wallet');
        this.$balanceInput = $module.find('#auto_replenishment_rule_balance');
        this.$amountInput = $module.find('#auto_replenishment_rule_amount');
        this.$limitInput = $module.find('#auto_replenishment_rule_limit');

        this.bind();
    }

    bind() {
        let self = this;

        [this.$balanceInput, this.$amountInput, this.$limitInput].forEach(function ($el) {
            new IMask($el.get(0), maskOptions);
        });

        this.$walletSelector.dropdown('setItemHandler', function (e) {
            e.preventDefault();
            self.$walletInput.val($(this).data('value')).trigger('change');
        });

        this.$walletSelector.find('.b-dropdown__item_regular').trigger('click');
    }
}

$(function () {
    $('.js-auto-replenishment').each(function () {
        new Module($(this));
    });
});
